import {
  Flex,
  IconButton,
  Tooltip,
  useClipboard,
  CopyIcon,
  CheckmarkIcon,
  IconButtonProps,
  TooltipProps,
} from '@frontend/components';

type CopyToClipboardTooltipProps = Omit<TooltipProps, 'label' | 'children'>;

type CopyToClipboardButtonProps = IconButtonProps &
  CopyToClipboardTooltipProps & {
    copyText: string;
    tooltipProps?: CopyToClipboardTooltipProps;
  };

const CopyToClipboardButton = ({
  copyText,
  size = 'lg',
  tooltipProps,
  ...iconButtonProps
}: CopyToClipboardButtonProps) => {
  const { onCopy, hasCopied } = useClipboard(copyText);

  const _tooltipProps = hasCopied
    ? {
        ...tooltipProps,
        label: (
          <Flex alignItems="center" gap={0.5}>
            <CheckmarkIcon />
            Copied
          </Flex>
        ),
        isOpen: true,
      }
    : {
        ...tooltipProps,
        label: 'Copy to clipboard',
      };

  return (
    <Tooltip {..._tooltipProps}>
      <IconButton
        size={size}
        {...iconButtonProps}
        onClick={onCopy}
        type="button"
      >
        <CopyIcon />
      </IconButton>
    </Tooltip>
  );
};

export default CopyToClipboardButton;
